import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { Form, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { offsetArr } from "../../utils/CommonConfig";
import { BASE_URL_APISERVICES } from "../../utils/Constants";
import swal from "sweetalert";
import { generateHashKey2 } from "../../utils/utilFuctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Digibanner from "../../../assets/images/digi_khata_1.webp";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { RetailerApi_Endpoint } from "../../utils/RetailerApiEndpoint";
const contentStyles = {
    width: "100%",
};
const tdstyle = {
    fontSize: "0.8rem",
    fontFamily: "Poppins",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
};
const thstyle = {
    color: "dark",
    backgroundColor: "white",
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
};
const DigiPaymentSystem = () => {
    const initialState = {
        name: "",
        code: "",
        service: "",
    };
    const history = useHistory();

    const [state, setState] = useState(initialState);
    const [data, setData] = useState([{}]);
    const [mdShow, setMdShow] = useState(false);

    const [dataToDisplay, setDataToDisplay] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [offset, setOffset] = useState(10);
    const [pages, setPages] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [balance, setBalance] = useState({});
    // const [merchantName, setmerchantName] = useState("");
    // const [merchantMobile, setmerchantMobile] = useState("");
    // const [merchantNameError, setmerchantNameError] = useState("");
    // const [merchantMobileError, setmerchantMobileError] = useState("");
    const [toggle, setToggle] = useState(false);
    const {
        user,
        setTransactionLoaderState,
    } = useContext(GlobalContext);

    const [merchantName, setmerchantName] = useState("");
    const [merchantNameError, setmerchantNameError] = useState("");

    const [merchantMobile, setmerchantMobile] = useState("");
    const [merchantMobileError, setmerchantMobileError] = useState("");

    const [otp, setOtp] = useState(""); // Stores entered OTP
    const [otpSent, setOtpSent] = useState(false); // Controls OTP input field visibility

    const [resendOtpEnable, setResendOtpEnable] = useState(false); // Controls resend OTP logic
    const [seconds, setSeconds] = useState(60); // Countdown timer for OTP resend

    const [showOtpSection, setShowOtpSection] = useState(false);
    const [otpToken, setOtpToken] = useState("");



    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
        setTotal(filteredData.length);
        const startIdx = 0;
        const endIdx = offset - 1;
        filteredData = filteredData.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        setCurrentPage(1);
    }, [searchText]);

    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        console.log(filteredData);
        const startIdx = (currentPage - 1) * offset;
        const endIdx = currentPage * offset - 1;
        console.log({ startIdx, endIdx });
        filteredData = filteredData.filter((bank, idx) => {
            console.log(idx, idx <= endIdx && idx >= startIdx);
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        console.log({ startIdx, endIdx });
    }, [currentPage]);

    // did mount
    useEffect(() => {
        setPages(Math.floor((data.length + (offset - 1)) / offset));
        const startIdx = 0;
        const endIdx = offset - 1;
        setTotal(data.length);
        console.log(startIdx);
        console.log(data);
        const filteredData = data.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        console.log(filteredData);
        setDataToDisplay(filteredData);
    }, [data, offset]);

    const validation_addMerchant = () => {
        if (!merchantName && !merchantName) {
            setmerchantNameError("Please enter name ");
            setmerchantMobileError("Please enter mobile number ");
            return;
        }
        if (!merchantName) {
            setmerchantNameError("Please enter name ");
            return;
        }
        if (!merchantMobile) {
            setmerchantMobileError("Please enter mobile number ");
            return;
        }
        // AddMerchant();
    };

    const clear_addMerchantForm = () => {
        setmerchantNameError("");
        setmerchantMobileError("");
        setmerchantName("");
        setmerchantMobile("");
    };


    const twoDecimalPlaces = (value) => {
        return Number(value).toFixed(2).toString();
    };

    const searchBarStyle = {
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "0px",
        backgroundColor: "#fff",
        width: "25%",
        height: "20%",
    };
    const inputStyle = {
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
        fontSize: "16px",
        marginLeft: "8px",
        width: "100%",
        fontFamily: "Poppins",
        fontWeight: "400",
    };
    const iconStyle = {
        color: "rgba(0, 0, 0, 0.5)",
    };

    const loginWithOtp = async (callback) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                userid: user.ReferId,
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.DIGI_KHATA_GENERATE_LOGIN_OTP}`,
                requestOptions
            );
            const data = await res.json();

            if (data.responseCode === "00") {
                swal("Success", data.responseMessage, "success");
                setShowOtpSection(true);
                setOtpToken(data.data.otpToken);
            } else {
                swal("Failed", data.responseMessage, "error");
                setShowOtpSection(false);
            }

            setTransactionLoaderState(false);
        } catch (error) {
            setTransactionLoaderState(false);
            console.log("error", error);

            swal("Error", "Network error. Please check your connection and try again!", "error");
            setShowOtpSection(false);
        }
    };
    const validateLoginOtp = async (callback) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                userid: user.ReferId,
                otp: state.name,
                token: otpToken
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.DIGI_KHATA_VALIDATE_LOGIN_OTP}`,
                requestOptions
            );
            const data = await res.json();

            if (data.responseCode == "00") {
                swal("Success", data.responseMessage, "success");
                history.push("/retailer/digi-khata-account-list");
            } else {
                swal("Failed", data.responseMessage, "error");
            }
        } catch (error) {
            console.log("error", error);
            swal("Error", "Network error. Please try again!", "error");
        }
    };



    return (
        <div className="bg-light p-2" style={{ fontFamily: "poppins" }}>
            <div style={contentStyles} className="scrollable-content">
                <div className="row">
                    <div className="col">

                        <img src={Digibanner}
                            style={{ width: "100%", height: "auto" }} />

                    </div>
                    <div className="col">
                        <div style={{ borderRadius: "8px" }} className="card m-0 p-0 mt-4 mr-2 ml-2">
                            <div className="card-body m-0 p-1 px-2">
                                <div>

                                    <div className="p-2 pl-1"
                                        style={{
                                            "fontFamily": "Poppins", "fontSize": "32px", "fontWeight": "600", "lineHeight": "48px", "letterSpacing": "0em", "textAlign": "left"
                                            , padding: "0px",
                                            background: "#FFFFFF",
                                            color: "#4267B2",
                                            fontWeight: "bolder",
                                            fontfamily: "Poppins !impotent",
                                            fontSize: "28px",
                                        }}
                                    >
                                        Digi Khata
                                    </div>

                                    <div>

                                        <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
                                            <div className="col-5 pr-3 m-0 p-0 ">
                                                <Form.Group>

                                                    <Form.Control
                                                        type="text"
                                                        className="form-control rounded-lg"
                                                        aria-label="Notes"
                                                        aria-describedby="basic-addon1"
                                                        placeholder="Enter User Code"
                                                        value={user.ReferId}
                                                        readOnly
                                                        style={{ borderRadius: "0px" }}
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="col-5 p-0 m-0 pr-3">
                                                <Button
                                                    className="rounded-10 btn-block  "
                                                    variant="primary"
                                                    onClick={loginWithOtp}
                                                >

                                                    Send OTP
                                                </Button>
                                            </div>

                                        </div>

                                        {showOtpSection && (
                                            <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
                                                <div className="col-5 pr-3 m-0 p-0 ">
                                                    <Form.Group>
                                                        <Form.Control
                                                            type="text"
                                                            className="form-control rounded-lg"
                                                            aria-label="Notes"
                                                            aria-describedby="basic-addon1"
                                                            placeholder="Enter OTP"
                                                            value={state.name}
                                                            onChange={(e) => {
                                                                setState({ ...state, name: e.target.value });
                                                            }}
                                                            style={{ borderRadius: "0px" }}
                                                        />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-5 p-0 m-0 pr-3">
                                                    <Button
                                                        className="rounded-10 btn-block"
                                                        variant="primary"
                                                        onClick={validateLoginOtp}
                                                    >
                                                        Verify OTP
                                                    </Button>
                                                </div>
                                            </div>
                                        )}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export const Pagination = ({
    page,
    limit,
    callback,
    total,
    count,
    callback2,
}) => {
    console.table({ page, limit, callback });
    const selectStyleLeftBorder = {
        borderRadius: "0px",
        fontFamily: "Poppins",
        fontsize: "16px",
        borderRight: "1px solid rgba(0, 0, 0, 0.2)", // Remove the border
        borderRadius: "0px",
        borderLeft: "none", // Remove right side border
        borderTop: "none", // Remove top border
        borderBottom: "none", // Remove bottom border
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    const selectStyleBorder = {
        border: "1px solid rgba(0, 0, 0, 0.1)", // Remove the border
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    const selectStyle = {
        border: "none", // Remove the border
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    return (
        <div
            className="row"
            style={{
                display: "flex",
                alignItems: "end",
                width: "100%",
                margin: "10px 0px",
                justifyContent: "space-between",
            }}
        >
            <div style={{ fontFamily: "Poppins" }}>
                <strong>{`Showing ${count} of ${total} entries`}</strong>
            </div>

            <div className="d-flex btn-group p-1" style={selectStyleBorder}>
                <select
                    style={selectStyleLeftBorder}
                    className=" d-flex justify-content-end "
                    aria-label="offset"
                    onChange={(e) => {
                        callback2(e.target.value);
                    }}
                >
                    {offsetArr.map((offset) => (
                        <option value={offset} className="d-flex justify-content-end">
                            {offset}
                        </option>
                    ))}
                </select>
                {page - 2 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {"<<"}
                    </Button>
                ) : null}

                {page - 1 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white underline-text"
                    >
                        {" "}
                        {(page - 1).toString()}
                    </Button>
                ) : null}

                <Button className="bg-white text-primary " style={selectStyle}>
                    {" "}
                    {page.toString()}
                </Button>

                {/* Next And Previous Button Code */}
                {page + 1 <= limit ? (
                    <Button
                        onClick={() => {
                            callback(page + 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {">>"}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};
export default DigiPaymentSystem;